/**
 * MinusCircleIcon Component
 *
 * Circle outline with a horizontal dash inside.
 * Used in delete confirmation dialogs.
 */

export function MinusCircleIcon({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="11.25" stroke="currentColor" strokeWidth="1.5" />
      <path d="M7.5 12H16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
